import { actions } from "./action-list";

export function setAllOperatorsExpenses(value) {
  return {
    type: actions.FETCH_ALL_OPERATOR_EXPENSES,
    value,
  };
}

export function clearOperatorExpenseList(value) {
  return {
    type: actions.CLEAR_OPERATOR_EXPENSE_LIST,
    value,
  };
}

export function operatorExpensesCreated(value) {
  return {
    type: actions.CREATE_OPERATOR_EXPENSES,
    value,
  };
}

export function setOperatorExpenseList(value) {
  return {
    type: actions.FETCH_OPERATOR_EXPENSE_LIST,
    value,
  };
}

export function expenseUploadSheetFailure(value) {
  return {
    type: actions.EXPENSE_UPLOAD_FAILURE,
    value,
  };
}
